<div class="popup-div">
     <div class="flex justify-between items-center pb-3">
        <div class="flex gap-4 items-center">
            <div class="yellow-bar"></div>
            <h1 class="sub-text text-center">Upload Custom Icon</h1>
        </div>
        <img src="../../../assets/Icons/close-icon.svg" class="close-icon" (click)="close()" style="cursor: pointer" />
    </div>
    <div class="flex flex-col justify-center items-center gap-8">
        <div class="w-full max-2xl:w-full image-upload-section">
            <div class="image-view-section w-full flex flex-row flex-wrap justify-start">
                <div class="w-full flex justify-center items-center" *ngIf="
                      selected_images?.length == 0 && image_loader == false
                    ">
                    <p class="card-text">Icon preview is shown here</p>
                </div>
                <div class="w-full max-sm:w-full p-2 relative" *ngFor="let img of selected_images; let i = index">
                    <div class="image-preview">
                        <img [src]="img?.url" class="uploaded-image" alt="" />
                    </div>
                    <div class="remove-button absolute flex items-center justify-center p-2">
                        <button class="w-full h-full icon" mat-raised-button matTooltip="Remove image"
                            aria-label="Button that displays a tooltip when focused or hovered over"
                            (click)="deletProduct(img)">
                            <img src="../../../../assets/Icons/remove.svg" />
                        </button>
                    </div>
                </div>
                <div *ngIf="image_loader"
                    class="w-full max-sm:w-full max-sm:flex-col flex flex-row justify-center items-center">
                    <mat-spinner class="button-loader w-full flex" diameter="20"></mat-spinner>
                </div>
            </div>
            <div class="upload-btn-section w-full flex justify-center items-center"
                *ngIf="selected_images?.length != 1 && !image_loader">
                <div>
                    <button class="flex flex-col items-center" (click)="fileUpload?.click()">
                        <span><img src="../../../../assets/Icons/upload.svg" /></span>
                        <span>Upload Icon</span>
                        <input hidden type="file" multiple #fileUpload accept="image/*"
                            (change)="onFileChange($event)" />
                    </button>
                </div>
            </div>
        </div>
         <div class="w-full flex items-center justify-center mt-12">
                    <button class="button-submit flex justify-center items-center max-w-sm"
                        (click)="submit()">
                        <span *ngIf="!button_loader">Add Icon</span>
                        <mat-spinner class="button-loader" *ngIf="button_loader" diameter="20"></mat-spinner>
                    </button>
                </div>
    </div>

</div>